<template>
  <nav-bar title="人员列表" />
  <Content :bottom="0" >
    <Loading v-if="showLoading" :isLoading="isLoading" @reload="getDataLoading" />
    <organizational-menu :list="list" />
  </Content>
</template>

<script>
import { ref } from 'vue'
import { employeeList } from '@/api/list'
import { useGetDataLoading } from '@/hooks/useGetDataLoading'
export default {
  name: 'PersonnelList', // 人员列表
  provide: {
    hideOperation: true
  },
  setup () {
    // 获取人员列表
    const list = ref([])
    const { getDataLoading, showLoading, isLoading } = useGetDataLoading(employeeList, (data) => {
      list.value = data
    })
    getDataLoading()

    return { list, showLoading, isLoading, getDataLoading }
  }
}
</script>

<style lang="scss" scoped>

</style>
